import { PermissionsContextProvider } from "./PermissionsContext";
import { TenantContextProvider } from "./TenantContext";
import { UserContextProvider } from "./UserContext";
import { UsersStatusContextProvider } from "./UsersStatusContext";

const AppContextProvider = ({ children }) => {
  return (
    <PermissionsContextProvider>
      <TenantContextProvider>
        <UsersStatusContextProvider>
          <UserContextProvider>{children}</UserContextProvider>
        </UsersStatusContextProvider>
      </TenantContextProvider>
    </PermissionsContextProvider>
  );
};

export default AppContextProvider;
